// frontend/src/App.js or any component
import { useEffect } from "react";
import { BrowserRouter, Route, Routes, useNavigate } from "react-router-dom";
// Layout components
import ConsentBanner from "./components/consent/ConsentBanner";
import AuthLayout from "./components/layout/AuthLayout";
import HeaderFooterLayout from "./components/layout/HeaderFooterLayout";
import ResponsiveLayout from "./components/layout/ResponsiveLayout";
// Route configurations
import InstallPrompt from "./components/pwa/InstallPrompt";
import { AuthProvider } from "./contexts/AuthContext";
import { ToastProvider } from "./contexts/ToastContext";
import { NotFound } from "./pages/NotFound";
import { HeaderFooterRoutes, HeaderOnlyRoutes } from "./routes/AppRoutes";
import { AuthRoutes } from "./routes/AuthRoutes";
// API Service
import apiService from "./services/api";

function AppRoutes() {
  const navigate = useNavigate();

  useEffect(() => {
    // Set up global navigation handler for API service
    apiService.setNavigationHandler(navigate);
  }, [navigate]);

  return (
    <Routes>
      {/* Routes with header and footer */}
      <Route path="/" element={<HeaderFooterLayout />}>
        {HeaderFooterRoutes}
      </Route>

      {/* Routes with responsive layout (header on mobile, sidebar on desktop) */}
      <Route path="/" element={<ResponsiveLayout />}>
        {HeaderOnlyRoutes}
      </Route>

      {/* Auth routes with auth layout */}
      <Route path="/" element={<AuthLayout />}>
        {AuthRoutes}
      </Route>

      {/* Catch-all route for 404 errors - must be last */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

function App() {
  return (
    <ToastProvider>
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <InstallPrompt />
          <ConsentBanner />
        </AuthProvider>
      </BrowserRouter>
    </ToastProvider>
  );
}

export default App;
